import { render, staticRenderFns } from "./legacy.vue?vue&type=template&id=0452110d&scoped=true&"
import script from "./legacy.vue?vue&type=script&lang=js&"
export * from "./legacy.vue?vue&type=script&lang=js&"
import style0 from "./legacy.vue?vue&type=style&index=0&id=0452110d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452110d",
  null
  
)

export default component.exports